import { createSelector } from 'reselect';
import { ApplicationRootState } from 'types';
import { initialState } from './reducer';

/**
 * Direct selector to the accountInfoPage state domain
 */

const selectAccountInfoPageDomain = (state: ApplicationRootState) => {
  return state ? state : initialState;
};

/**
 * Other specific selectors
 */

/**
 * Default selector used by AccountInfoPage
 */

const selectAccountInfoPage = () =>
  createSelector(selectAccountInfoPageDomain, substate => {
    return substate;
  });

export default selectAccountInfoPage;
export { selectAccountInfoPageDomain };
